import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { Button } from 'components/Button'
import { Box, Container } from 'components/Layout'
import { Text } from 'components/Typography'
import { COLOR_INTENT, FONT_STACK, FONT_WEIGHT, SPACE } from 'Theme'

const { TRADE_PAGE } = COLOR_INTENT.WIDGETS

const ApplyCta = styled(Button)`
  background: ${TRADE_PAGE.TEXT_ON_DARK};
  color: ${TRADE_PAGE.BANNER_BG};
  text-transform: uppercase;
  letter-spacing: 0.14em;

  &:hover {
    background: ${TRADE_PAGE.WHITE};
  }
`

export const ReadyToJoinSection: React.FC = () => (
  <Box backgroundColor={TRADE_PAGE.BANNER_BG}>
    <Container
      py={{ MOBILE: rem(56), TABLET: rem(90) }}
      px={{ MOBILE: SPACE.PX_24, TABLET: SPACE.PX_40 }}
      style={{ textAlign: 'center' }}
    >
      <Text
        as="h2"
        fontFamily={FONT_STACK.SERIF}
        fontWeight={FONT_WEIGHT.NORMAL}
        fontSize={{ MOBILE: rem(32), TABLET: rem(40) }}
        color={TRADE_PAGE.TEXT_ON_DARK}
        mb={0}
      >
        Ready to join?
      </Text>
      <Box
        mt={{ MOBILE: rem(28), TABLET: rem(40) }}
        width={{ MOBILE: '100%', TABLET: 'fit-content' }}
        mx={{ MOBILE: 0, TABLET: 'auto' }}
      >
        <ApplyCta
          onClick={() => {
            document
              .getElementById('form')
              ?.scrollIntoView({ behavior: 'smooth' })
          }}
        >
          Apply for Trade Access
        </ApplyCta>
      </Box>
    </Container>
  </Box>
)
